import config from 'configs/app';

const BRAND_NAME = 'BOT Chain';

const HOST_NET_LABEL = {
  'scan.botchain.ai': 'Mainnet',
  'scan.botchain.me': 'Prenet',
  'scan.bohr.life': 'Testnet',
  'scan-dev.bohr.life': 'Devnet',
  localhost: 'Testnet',
  '127.0.0.1': 'Testnet',
} as const;

type ApiDocsNetLabel = typeof HOST_NET_LABEL[keyof typeof HOST_NET_LABEL];

export function getApiDocsNetLabel(host = config.app.host): ApiDocsNetLabel {
  return HOST_NET_LABEL[host as keyof typeof HOST_NET_LABEL] ?? 'Devnet';
}

export default function getApiDocsTitle(host = config.app.host) {
  return `${ BRAND_NAME } ${ getApiDocsNetLabel(host) } API documentation`;
}
